<script setup lang="ts">

defineProps<{
  informationBannerData?: any;
  isLoading?: boolean;
}>();

const bannerShowState = ref(true);

const closeBanner = () => {
  bannerShowState.value = false;
};

</script>

<template>
  <div 
    v-if="bannerShowState" 
    class="top-bar relative z-40 lg:z-[49] h-[50px] md:h-[35px] w-full text-center text-white bg-primary"
    :style="informationBannerData?.bgColorCode ? { backgroundColor: informationBannerData?.bgColorCode } : {}"
  >
    <div class="container relative">
      <div class="flex justify-center items-center py-[5px] h-[50px] md:h-[34px]">
        <template v-if="isLoading">
          <!-- Skeleton loader -->
          <div class="animate-pulse w-48 md:w-64 h-4 bg-white/30 rounded"></div>
        </template>
        <template v-else-if="informationBannerData">
          <span
            class="top-bar-text text-[14px] md:text-md leading-[18px] md:leading-[22px] 3xl:text-lg font-marcellus max-w-[70%] md:max-w-[80%] line-clamp-2"
            :style="informationBannerData?.fontColorCode ? { color: informationBannerData?.fontColorCode } : {}"
            v-html="informationBannerData?.translated.description"
          ></span>
          <button
            class="close-button ml-0 sm:ml-4 absolute right-[20px] top-[15px] sm:relative sm:top-0 sm:right-0"
            :aria-label="$t('header.ariaLabelClose')"
            @click="closeBanner()">
            <i class="icon-close-outline font-bold"></i>
          </button>
        </template>
      </div>
    </div>
  </div>
</template>